import React from 'react';

// Empty-state mark for Bulk / Pitch Deck Analysis: a gradient sparkle inside the
// shared gradient-bordered tile. Rendered at its native 80px (the artwork was
// drawn in an 80x80 viewBox); the frame is part of the artwork.
// Gradient ids are per-instance (useId) so multiple copies on a page don't collide.
const NoAnalysisIcon = ({ size = 80 }) => {
  const uid = React.useId();
  const g = (n) => `no_analysis_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="79" height="79" rx="11.5" stroke={`url(#${g(0)})`} />
      <path
        d="M36.5 22L40.087 36.087L53 40L40.087 43.913L36.5 58L32.913 43.913L20 40L32.913 36.087L36.5 22Z"
        fill={`url(#${g(1)})`}
      />
      <path
        d="M53 27L54.5 31.5L59 33L54.5 34.5L53 39L51.5 34.5L47 33L51.5 31.5L53 27Z"
        fill={`url(#${g(2)})`}
      />
      <defs>
        <linearGradient id={g(0)} x1="40" y1="0" x2="40" y2="80" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7853F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
        <linearGradient id={g(1)} x1="11.75" y1="31" x2="47.6142" y2="63.8755" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
        <linearGradient id={g(2)} x1="44" y1="30" x2="56" y2="42" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7852F8" />
          <stop offset="1" stopColor="#84AEF6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NoAnalysisIcon;
